import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteSectorDeInfraccion,
  getSectoresDeInfracciones,
  patchSectorDeInfraccion,
  postSectorDeInfraccion,
} from 'api/recaudacion/sectoresDeInfraccion';

// eslint-disable-next-line react/prop-types
const sectoresDeInfracciones = ({ permission }) => (
  <PlainCRUD
    title="Sectores de infracción"
    permission={permission}
    get={getSectoresDeInfracciones}
    post={postSectorDeInfraccion}
    patch={patchSectorDeInfraccion}
    delete={deleteSectorDeInfraccion}
    withoutState
    fields={[
      defaultFields.clave,
      defaultFields.descripcion,
      {
        name: 'visible_en_presentacion',
        label: '¿Visible en presentación?',
        type: 'select',
      },
      {
        name: 'seleccionable_en_presentacion',
        label: '¿Seleccionable en presentación?',
        type: 'select',
      },
      {
        name: 'orden_de_presentacion',
        label: 'Orden de presentacion',
      },
      {
        name: 'observaciones',
        label: 'Observaciones',
        type: 'textarea',
        colWidth: 200,
        autoSize: { minRows: 3, maxRows: 4 },
      },
    ]}
  />
);

export default sectoresDeInfracciones;
